import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { MatchCreateNewTabs } from '@user/components/Location/MatchCreateNew/MatchCreateNewTabs'
import { CreateLocationModal } from '@user/components/Location/CreateLocationModal'
import { MatchCreateLocationFlow } from './useMatchCreateLocationFlow'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  flow: MatchCreateLocationFlow
  title?: string
  tidalThemeActive?: boolean
  addToPestPac?: boolean
}

export function MatchCreateLocationDialogs(props: Props) {
  const {
    entityId,
    entityType,
    flow,
    title = 'Create Location',
    tidalThemeActive,
    addToPestPac,
  } = props

  return (
    <>
      <FullScreenDialog
        open={flow.matchOverlayOpen}
        onClose={flow.onMatchOverlayClose}
        closeButtonText="Close Match / Create New"
      >
        <MatchCreateNewTabs
          {...flow.createLocParams}
          matchLocationTitle={flow.matchLocationTitle}
          onClose={flow.onMatchTabsClose}
        />
      </FullScreenDialog>
      <CreateLocationModal
        open={flow.createLocationOpen}
        onClose={flow.onCreateLocationClose}
        entityId={entityId}
        entityType={entityType}
        title={title}
        tidalThemeActive={tidalThemeActive}
        onNewLocationsSave={flow.handleCreateNewLocation}
        addToPestPac={addToPestPac}
      />
    </>
  )
}
MatchCreateLocationDialogs.displayName = 'MatchCreateLocationDialogs'
